console.log("Hello from home.js on vite")
import "./application";
import '../apps/search/main.ts';
